import { trackDemoClick } from "@/lib/telemetry";

export const TopBar = () => {
  return (
    <div className="bg-secondary border-b border-border">
      <div className="container mx-auto px-6 py-3 flex items-center justify-between">
        <div className="text-foreground text-xs sm:text-sm font-medium">
          datasyteAI™ — Expert-trained decision support for Code Blue
          <span className="hidden sm:inline">
            {" "}
            · Pre-market: not FDA cleared, not for clinical use
          </span>
        </div>
        <a
          href="https://pathfree.com/contact" onClick={() => trackDemoClick("top_bar")}
          className="text-primary text-sm font-bold hover:bg-primary/10 transition-colors px-4 py-1.5 border border-primary/45 rounded-lg"
        >
          Request a Demo
        </a>
      </div>
    </div>
  );
};
